import React, { useState } from "react";
import {
  LoaderWrapper,
  ManageTransactionLayout,
  PendingApprovalCard,
  FieldInput,
  FieldDropSide,
  MultiSelectDropdown,
  DatePicker,
  TransactionHistoryDetailTile,
} from "../../../components";
import { useLocation } from "react-router-dom";
import {
  OPTIONS_DATA_MAPPER,
  required,
  toMultiSelectValue,
  toOptionValuesFromMapper,
  usDateFormat,
  toMultiSelectValueById,
} from "../../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactComponent as CoreLogo } from "../../Mapper/MapperHomeContainer/core.svg";
import {
  faBracketsCurly,
  faFileSpreadsheet,
} from "@fortawesome/pro-light-svg-icons";
import { Formik, Field } from "formik";
import { Form, Button, Image, Tab, Tabs } from "react-bootstrap";
import { isEmpty } from "lodash";
import ExcelImage from "../../../styles/exportimg.PNG";
import Employeepic from "../../../assets/employeePhoto.jpeg";
import {
  DistributionDetails,
  SourceAllocationMapping,
  InvestmentMapping,
} from "./RollOverIn";
import {
  Payee,
  Withdrawal,
  SourceInvestmentSplitup,
  UploadedDocuments,
  Trade,
} from "./Distribution";
import { SourceDetails } from "./Transfer";
import { LoanRepaymentDetails, PaymentMethod } from "./Loan";
import Data from "../../../mocks/transactionHistory.json";
const HistoryDetails = (props) => {
  const location = useLocation();
  const [keyValue, setkeyValue] = useState(1);
  const transactionType = location.pathname.split("/")[2].split("-")[0];
  const [nextkeyValue, setNextkeyValue] = useState(keyValue);
  const menuChange = (key) => {
    setkeyValue(key);
  };
  return (
    <ManageTransactionLayout layoutHeader="Transaction History Details">
      <TransactionHistoryDetailTile data={Data[0]} />
      <div className="mt-3">
        {transactionType === "rollover" && (
          <Tabs
            defaultActiveKey={1}
            transition={false}
            className="top-level-tab"
            onSelect={menuChange}
            activeKey={keyValue}
            mountOnEnter
            unmountOnExit
          >
            {/* <Tab eventKey="plan_summary" title="Plan summary">
              <PlanSummary />
            </Tab> */}
            <Tab eventKey={1} title="Distributing Plan Details">
              <DistributionDetails />
            </Tab>
            <Tab eventKey={2} title="Source Allocation Mapping">
              <SourceAllocationMapping />
            </Tab>
            <Tab eventKey={3} title="Investment Mapping">
              <InvestmentMapping />
            </Tab>

            <Tab eventKey={4} title="Trade">
              <Trade />
            </Tab>
          </Tabs>
        )}
        {transactionType === "withdrawal" && (
          <Tabs
            defaultActiveKey={1}
            transition={false}
            className="top-level-tab"
            onSelect={menuChange}
            activeKey={keyValue}
            mountOnEnter
            unmountOnExit
          >
            {/* <Tab eventKey="plan_summary" title="Plan summary">
              <PlanSummary />
            </Tab> */}
            <Tab eventKey={1} title="Withdrawal">
              <Withdrawal />
            </Tab>
            <Tab eventKey={2} title="Source & Investment Splitup">
              <SourceInvestmentSplitup />
            </Tab>
            <Tab eventKey={3} title="Payee">
              <Payee />
            </Tab>

            <Tab eventKey={4} title="Uploaded Documents">
              <UploadedDocuments />
            </Tab>
            <Tab eventKey={5} title="Trade">
              <Trade />
            </Tab>
          </Tabs>
        )}
        {transactionType === "transfer" && (
          <Tabs
            defaultActiveKey={1}
            transition={false}
            className="top-level-tab"
            onSelect={menuChange}
            activeKey={keyValue}
            mountOnEnter
            unmountOnExit
          >
            {/* <Tab eventKey="plan_summary" title="Plan summary">
              <PlanSummary />
            </Tab> */}
            <Tab eventKey={1} title="Sources Detail">
              <SourceDetails />
            </Tab>

            <Tab eventKey={2} title="Trade">
              <Trade />
            </Tab>
          </Tabs>
        )}
        {transactionType === "loan" && (
          <Tabs
            defaultActiveKey={1}
            transition={false}
            className="top-level-tab"
            onSelect={menuChange}
            activeKey={keyValue}
            mountOnEnter
            unmountOnExit
          >
            <Tab eventKey={1} title="Loan Repayment Details">
              <LoanRepaymentDetails />
            </Tab>
            <Tab eventKey={2} title="Payment Method">
              <PaymentMethod />
            </Tab>

            <Tab eventKey={3} title="Trade">
              <Trade />
            </Tab>
          </Tabs>
        )}
      </div>
    </ManageTransactionLayout>
  );
};

export default HistoryDetails;
